module.exports = "/images/vendor/desiigner-svg/svg/places/backpack.svg?17df8203c90828573f4b4ba1880c2ee1";